import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Gallery.css';

import img1 from '../../assets/Gallery/g (1).jpeg';
import img2 from '../../assets/Gallery/g2 (2).jpeg';
import img3 from '../../assets/Gallery/g2 (3).jpeg';
import img4 from '../../assets/Gallery/g2 (4).jpeg';
import img5 from '../../assets/Gallery/g2 (5).jpeg';
import img6 from '../../assets/Gallery/g2 (6).jpeg';
import img7 from '../../assets/Gallery/g2 (7).jpeg';
import img8 from '../../assets/Gallery/g2 (8).jpeg';
import img9 from '../../assets/Gallery/g2 (9).jpeg';

const galleryItems = [
  {
    image: img1,
    title: "Smart Control Panel",
    description: "Centralized smart panel with energy automation modules and real-time monitoring for industrial use."
  },
  {
    image: img2,
    title: "AI Security Integration",
    description: "High-definition surveillance integrated with AI-based motion detection and remote alert systems."
  },
  {
    image: img3,
    title: "Healthcare Automation Hub",
    description: "Automated nurse call and monitoring system in hospitals for enhanced patient care and efficiency."
  },
  {
    image: img4,
    title: "IoT Device Dashboard",
    description: "Live status dashboard showing device communication and automation activity within industrial IoT setups."
  },
  {
    image: img5,
    title: "Warehouse Power Optimization",
    description: "Advanced load balancing and power management system in a large-scale automated warehouse."
  },
  {
    image: img6,
    title: "GRMS Hotel Room",
    description: "Luxury hotel guest room equipped with smart lighting, climate control, and touch panel GRMS system."
  },
 {
  image: img7,
  title: "WordPress & SEO Developer",
  description: "Specializes in building energy systems with smart BMS control, climate regulation, and lighting automation."
},
{
  image: img8,
  title: "React.js Developer",
  description: "Expert in solar-powered controllers for remote monitoring, equipped with battery backup and weather resistance."
},
{
  image: img9,
  title: "Senior Developer",
  description: "Leads development of dual smart controllers enabling advanced energy management and real-time diagnostics."
}

];

const Gallery = () => {
  return (
    <Container className="gallery-container py-5">
      <h2 className="text-center fw-bold mb-4">Our Project Gallery</h2>
      <p className="text-center text-muted mb-5 px-4">
        Each image below showcases a real implementation of our Smart Industry solutions — designed to modernize energy, security, healthcare, hospitality, and automation sectors.
      </p>

      <Row className="g-5">
        {galleryItems.map((item, index) => (
          <Col key={index} xs={12} sm={6} md={6} lg={4}>
            <Card className="gallery-card h-100">
              <Card.Img
                variant="top"
                src={item.image}
                alt={`Gallery ${index + 1}`}
                className="gallery-img"
              />
              <Card.Body className="p-4">
                <Card.Title className="fw-semibold">{item.title}</Card.Title>
                <Card.Text className="text-muted small">{item.description}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Gallery;
